function ScrollContainer() {
  this.po = new PIXI.Container();
  this.scrollContainer = new PIXI.Container();
  this.po.addChild(this.scrollContainer);
  this.items = [];

  const scrollContainerWidth = 100;
  const scrollContainerHeight = 100;
  this.mask = new PIXI.Graphics();
  this.mask
  	.beginFill(0xFFFFFF)
  	.drawRect(0,0,window.innerWidth, window.innerHeight)
  	.endFill();

  this.po.addChild(this.mask);
  this.scrollContainer.mask = this.mask;

  var itemHeight = 100;

  var _this = this;

  var mousedown = false;
  var lastPos = null;
  var lastDiff = null;
  var scrollTween = null;
  var maxVel = 0;

  function onmousemove(e) {
      //console.log('e.originalEvent', e);
    //var clientY = !e.originalEvent.touches ? e.originalEvent.clientY : e.originalEvent.touches[0].clientY;
    var clientY = e.data.originalEvent.clientY

		if (mousedown) {
      lastDiff = clientY - lastPos.y;
      lastPos.y = clientY;

      if (-_this.scrollContainer.y < 0) {
        _this.scrollContainer.y += lastDiff/2;
      }else{
        _this.scrollContainer.y += lastDiff;
      }

    }
  }
  function onmousedown(e) {
    //var clientY = !e.originalEvent.touches ? e.originalEvent.clientY : e.originalEvent.touches[0].clientY;
    console.log('MOUSE DOWN!!!!!1');
    var clientY = e.data.originalEvent.clientY;

    mousedown = true;
    if (scrollTween) scrollTween.kill();
    lastPos = {
      y: clientY
    }
  }
  function onmouseup(e) {
      console.log('mouseup');
    if (lastDiff) {
      var goY = _this.scrollContainer.y + lastDiff * 10;
      /*
      var ease = Quad.easeOut;
      var time = Math.abs(lastDiff / 150);

      if (goY < -_this.items.length * itemHeight + window.innerHeight) {
				goY = -_this.items.length * itemHeight + window.innerHeight;
        ease = Back.easeOut;
        time = .1 + Math.abs(lastDiff / 150);
      }
      if (goY > 0)  {
				goY = 0;
        ease = Back.easeOut;
        time = .1 + Math.abs(lastDiff / 150);
      }

      if (_this.scrollContainer.y > 0) {
        time = 1 + _this.scrollContainer.y / 500;
        ease = Elastic.easeOut;
      }
      if (_this.scrollContainer.y < -_this.items.length * itemHeight + window.innerHeight) {
        time = 1 + (_this.items.length * itemHeight + window.innerHeight + _this.scrollContainer.y) / 500;
        ease = Elastic.easeOut;
      }
      */

      //scrollTween = TweenMax.to(_this.scrollContainer, time, {
        //y: goY,
        //ease: ease
      //});
      console.log('GOOOOOOOOOOO', goY);
      _this.scrollContainer.y = goY;
    }

    mousedown = false;
    lastPos = null;
    lastDiff = null;
  }

  this.po.interactive = true;
  this.po.mousemove = onmousemove;
  this.po.mousedown = onmousedown;
  this.po.mouseup = onmouseup;
  this.po.touchmove = onmousemove;
  this.po.touchstart = onmousedown;
  this.po.touchend = onmouseup;

  this.hideOffscreenElements = function() {
		var startIndex = Math.floor(-_this.scrollContainer.y / itemHeight);
    var endIndex = Math.floor(startIndex + (scrollContainerHeight / itemHeight));

    for (var i = 0; i < _this.items.length; i++) {
      var item = _this.items[i];
      item.visible = false;
      if (i >= startIndex && i <= endIndex + 1) {
        item.visible = true;
      }
    }
  }
}
function ListItem(label) {
  this.label = label;
  this.po = new PIXI.DisplayObjectContainer();

  this.bg = new PIXI.Graphics();
  this.bg
  	.beginFill(0xFFFFFF * Math.random())
  	.drawRect(0,0,window.innerWidth,100)
  	.endFill();

 	//this.bgSprite = new PIXI.Sprite(this.bg.generateTexture());
  this.text = new PIXI.Text(label);

  this.po.addChild(this.bg);
  this.po.addChild(this.text);
  //this.po.cacheAsBitmap = true;
}
export default ScrollContainer;
